// Layzise conf ----------------------------------------------------------------

window.lazySizesConfig = window.lazySizesConfig || {};
//page is optimized for fast onload event
lazySizesConfig.loadMode = 1;
lazySizesConfig.loadingClass = '';
lazySizesConfig.loadedClass = 'lazyloaded';
//lazySizesConfig.init = false;

var $ = jQuery.noConflict();

function googleMap() {

    var $map = $("#footer_map");

    if ($map.length) {

        var myLatlng = new google.maps.LatLng($map.attr('data-lat'), $map.attr('data-lng'));

        var mapOptions = {
            zoom: 14,
            center: myLatlng,
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{"featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{"color": "#444444"}]}, {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#f2f2f2"}]}, {"featureType": "poi", "elementType": "all", "stylers": [{"visibility": "off"}]}, {"featureType": "road", "elementType": "all", "stylers": [{"saturation": -100}, {"lightness": 45}]}, {"featureType": "road.highway", "elementType": "all", "stylers": [{"visibility": "simplified"}]}, {"featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{"visibility": "off"}]}, {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"}]}, {"featureType": "water", "elementType": "all", "stylers": [{"color": "#FF4169"}, {"visibility": "on"}]}]
        };

        var map = new google.maps.Map(document.getElementById('footer_map'), mapOptions);

        var contentString = '<div id="content">' +
                '<div id="siteNotice">' +
                '</div>' +
                '<div id="bodyContent">' + $map.attr('data-add') +
                '</div>' +
                '</div>';

        var infowindow = new google.maps.InfoWindow({
            content: contentString
        });

        //var iconBase = '/wp-content/themes/pizza/images/';

        var marker = new google.maps.Marker({
            position: myLatlng,
            map: map,
            //icon: iconBase + 'map-marker.png'
        });

        google.maps.event.addListener(marker, 'click', function () {
            infowindow.open(map, marker);
        });

    }
}

(function ($) {

    'use strict';

    if (!$.j3wThemeExtensions)
        $.j3wThemeExtensions = {};

    function J3WTheme() {

        var self = this;

        self.$window = $(window);
        self.$document = $(document);
        self.$body = $("body");
        self.$header = $("#header");

        self.$popup = $(".j3w-popup");
        self.$popupClose = $(".j3w-popup-close");

        self.$hamburgerDots = $("#hamburger-dots");
        self.$sideoutArea = $("#sideout-area");

        self.$headerVideo = $("#featured-school-bg video");
        self.$headerVideoContainer = $("#featured-school-bg");

        self.$peopele_work_popup = $('#people-work-panel');
        self.$swiper_container = $('#people-work-panel-swiper-container');
        self.$swiper_wrapper = self.$swiper_container.find('.swiper-wrapper');
        self.$peopleWorkPanelClose = $("#people-work-panel-close");

        self.$contactForm = $("#contact-form");
        self.contactAjax = false;

        self.$photoSwipeItem = $(".photoswipe-item");

        self.init();

    }

    J3WTheme.prototype = {

        init: function () {

            var self = this;

            // No touch: Init history/back-button support (push/pop-state)
            window.history.replaceState('', '', window.location.href);

            self.loadExtension();
            self.onBind();
            self.bodyScrollClass(self);
            self.archiveItemsCompleteText();
            self.mainMenu();
            self.swiperInit();
            self.masonryGalleryInit();
            self.masonrySingleGalleryInit();
            if($('#featured-school-bg').length){
                self.fullscreenBackgroundVideo();
            }
            self.contactFormValidate();
            self.photoSwipeInit();

        },

        loadExtension: function () {

            var self = this;

            // Program filter
            if ($.j3wThemeExtensions.filters) {
                $.j3wThemeExtensions.filters.call(self);
            }

        },

        onBind: function () {

            var self = this;

            self.$window.on('scroll', function () {
                self.bodyScrollClass(self);
            });
            
            $("#j3w-open-popup-search-form").on("click", function(e){
                
                $("#j3w-popup-search-form").addClass("show");
                
                e.preventDefault(); 
            });

            self.$popupClose.on("click", function () {
                $("#j3w-popup-submenu").removeClass("show");
                setTimeout(function(){
                  self.$popup.removeClass("show");
                }, 150); // waiting for submenu
            });
            
            $("#back-to-top").on("click", function(){
                $("html,body").animate({ scrollTop: 0 }, 300);
                return false;
            });
            
            $("#open-overview").on("click", function(){
                $(this).toggleClass("active");
                $("#overview-panel").toggleClass("open");
                if( typeof self.ovwSwiper === "undefined" ) {
                    self.overviewSwiperInit();
                }
                return false;
            });
            if($('#featured-school-bg').length){
                self.$window.on('resize', function(){
                    self.fullscreenBackgroundVideo();
                });
            }
            
            self.$headerVideo.on('loadedmetadata', function(){
                self.fullscreenBackgroundVideo();
            });
            
            $(".people-work-show").on("click", function(){
                self.fireSwiperForPeopleWork( $(this) );
            });
            
            // close popup people work
            self.$document.keydown(function(e){
                if(e.cancelable === true && e.key === 'Esc' || e.key === 'Escape' || e.keyCode === 27){
                    self.$peopele_work_popup.removeClass('show');
                    if( self.peopleWorkSwiper ){
                        self.peopleWorkSwiper.destroy(false, false);
                    }
                }
            });
            
            self.$peopleWorkPanelClose.on("click", function(){
                self.$peopele_work_popup.removeClass('show');
                self.peopleWorkSwiper.destroy(false, false);
            });
            
            $(".teaching-subjects-item").on("click", function(e){
                $(this).toggleClass("active");
                //e.preventDefault();
            });

        },

        mainMenu: function () {
            
            var self = this;
            
            var $popup = $("#j3w-popup-menu"),
                $popup_main_menu = $("#j3w-popup-main-menu"),
                $popup_submenu = $("#j3w-popup-submenu"),
                popup_main_menu_target = "#j3w-popup-main-menu",
                main_menu_class = "j3w-main-menu",
                $main_menu_li = $("#j3w-main-menu > li");

            self.$body.on("click", "#j3w-main-menu > li > a, #j3w-main-menu-header > li > a, #j3w-popup-main-menu > li > a, #j3w-side-main-menu > li > a", function (e) {
              
                // if has children
                if($(this).parent("li").find("ul").length > 0){

                    // reset active class
                    $(this).closest("ul").find("li").removeClass("active");
                    $(this).parent().addClass("active");
                
                    // clone main menu
                    // click in page
                    if($(this).closest("ul").hasClass(main_menu_class)){
                        // allways cloned
                        $popup_main_menu.html('');
                        $main_menu_li.clone().appendTo(popup_main_menu_target);
                    }
                    // click in popup
                    if(!$(this).closest("ul").hasClass(main_menu_class) && !$popup_main_menu.hasClass("cloned")){
                        // cloned once
                        $main_menu_li.clone().appendTo(popup_main_menu_target);
                    }
                
                    // hide submenu
                    $popup_submenu.removeClass("show");

                    // clone submenu to var
                    var $cloned_submenu = $(this).parent("li").find("ul").clone().find("li").removeAttr("id class").end();
                    setTimeout(function(){
                        // reset, add menu, show
                        $popup_submenu.html('').append($cloned_submenu).addClass("show");
                    }, 200);

                    // stop multiple cloned
                    $popup_main_menu.addClass("cloned");
                    
                    // show popup
                    $popup.addClass("show");
                
                    e.preventDefault();
                }

            });

            // click hamburger
            self.$body.on("click", "#hamburger-dots", function(){
                self.$body.toggleClass("modal-open");
                $("#j3w-main-menu:not(.cloned)").addClass("cloned")   
                                                .clone()
                                                .removeAttr("id class")
                                                .attr("id", "j3w-side-main-menu")
                                                .appendTo(self.$sideoutArea.find(".inner"))
                                                .find("li")
                                                .removeAttr("id class"); 
                self.$sideoutArea.toggleClass("open"); // open area
            });
            
            // click close button
            $("#sideout-area .alc-button").on("click", function(){
                self.$body.removeClass("modal-open");
                self.$sideoutArea.removeClass("open");
            });
            
            $(".featured-school-bg").on("click", function(){
                $(this).find("#j3w-school-menu-wrapper").toggleClass("open");
            });

        },

        overviewSwiperInit: function() {

            var self = this;

            self.ovwSwiper = new Swiper ('#overview-panel-swiper-container', {
                loop: true,
                autoplay: {
                    delay: 3600,
                    disableOnInteraction: true
                },
                speed: 600,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 3
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: false,
                },
                grabCursor: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            });

        },
        
        swiperInit: function(){
            
            var homepageSwiper = new Swiper ('#home-swiper-container', {
                roundLengths: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                initialSlide: 2,
                loop: true,
                loopedSlides: 3,
                loopAdditionalSlides: 2,
                autoplay: {
                    delay: 5500,
                    disableOnInteraction: true
                },
                speed: 900,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 3
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: false,
                },
                grabCursor: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                onClick: function(swiper, event){
                  console.log(swiper);
                  if($(swiper.clickedSlide).hasClass("swiper-slide")){
                    window.location = $(swiper.clickedSlide).find("a").attr("href");
                  }
                }
            });
            
        },
        
        fireSwiperForPeopleWork: function( $this ){
            
            var self = this;
            
            var $images = $this.closest('.people-work').find('.people-work-images').html();

            //$swiper_wrapper.html('');
            if( self.peopleWorkSwiper ){
                self.peopleWorkSwiper.removeAllSlides();
            }
            
            self.$swiper_wrapper.html( $images );
            
            self.$peopele_work_popup.addClass('show');
            
            self.peopleWorkSwiper = new Swiper ('#people-work-panel-swiper-container', {
                
                loop: true,
                autoplay: 3600,
                speed: 600,
                keyboardControl: true,
                grabCursor: true

            });
            
        },

        masonrySingleGalleryInit: function() {

            $("#masonry-single-gallery").masonry({
                itemSelector: '.single-gallery-brick',
                columnWidth: '.single-gallery-grid-sizer',
                horizontalOrder: true,
                //percentPosition: true,
                resize: true
            });

        },

        masonryGalleryInit: function () {

            var self = this;

            self.$window.load(function () {

                /* Blog grid (Packery) */
                var $blogUl = $('.j3w-masonry-grid');

                // Initialize Packery
                $blogUl.packery({
                    itemSelector: '.j3w-masonry-item',
                    gutter: 0,
                    isInitLayout: false // // Disable initial layout
                });

                // Packery event: "layoutComplete"
                /*
                 $blogUl.packery('once', 'layoutComplete', function() {
                 //setTimeout(function() {
                 $blogUl.removeClass('hide');
                 //}, 200);
                 });
                 */

                // Manually trigger initial layout
                $blogUl.packery();

            });

        },

        bodyScrollClass: function (self) {

            if ( self.$document.scrollTop() > self.$header.outerHeight() ) {
                // clone header
                $("#logo:not(.cloned), .j3w-responsive-menu-wrapper:not(.cloned)").addClass("cloned").clone(true,true).appendTo("#cloned-header-content");
                // odstranime ID toho UL - nemuzeme to mit dvakrat v dokumentu
                $("#cloned-header-content").find("#j3w-main-menu").attr("id", "j3w-main-menu-header");
                $("#open-overview").addClass("scroll");
                $("#cloned-header").addClass("down");
            } else {
                $("#open-overview").removeClass("scroll");
                $("#cloned-header").removeClass("down");
            }

        },
        
        fullscreenBackgroundVideo: function(){
            
            var self = this;

            // Video's intrinsic dimensions
            var w = self.$headerVideo[0].videoWidth,
                h = self.$headerVideo[0].videoHeight;

            // Intrinsic Ratio
            // Will be more than 1 if W > H and less if W < H
            var videoRatio = (w / h).toFixed(2);

            // Get the container's computed styles
            //
            // Also calculate the min dimensions required (this will be
            // the container dimentions)
            var minW = self.$headerVideoContainer.width(),
                minH = self.$headerVideoContainer.height();

            // What's the min:intrinsic dimensions
            //
            // The idea is to get which of the container dimension
            // has a higher value when compared with the equivalents
            // of the video. Imagine a 1200x700 container and
            // 1000x500 video. Then in order to find the right balance
            // and do minimum scaling, we have to find the dimension
            // with higher ratio.
            //
            // Ex: 1200/1000 = 1.2 and 700/500 = 1.4 - So it is best to
            // scale 500 to 700 and then calculate what should be the
            // right width. If we scale 1000 to 1200 then the height
            // will become 600 proportionately.
            var widthRatio = minW / w,
                heightRatio = minH / h;

            // Whichever ratio is more, the scaling
            // has to be done over that dimension
            if (widthRatio > heightRatio) {
                var newWidth = minW;
                var newHeight = Math.ceil(newWidth / videoRatio);
            } else {
                newHeight = minH;
                newWidth = Math.ceil(newHeight * videoRatio);
            }

            self.$headerVideo.css({ width : newWidth, height : newHeight }).addClass("loaded");
            
        },
        
        archiveItemsCompleteText: function(){
          
          $(".entry-title").hover(function(){
            
            var text = $(this).text();
            
            // check overflow
            if ($(this)[0].scrollHeight >  $(this).innerHeight()) {
              
              $(this).css({'height' : 'auto'});
              
              //$this.append('<div class="j3w-complete-text">' + text + '</div>');
            }
            
          }, function(){
            
            $(this).removeAttr("style");
            
          });
          
        },

        /**
         * Helper: Set browser history "pushState" (AJAX url)
         */
        setPushState: function (pageUrl) {

            var self = this;

            // Set browser "pushState"
            //if (self.hasPushState) {
            window.history.pushState('', '', pageUrl);
            //}

        },

        contactFormSubmit: function () {

            var self = this;

            self.contactAjax = $.ajax({
                url: ajaxCore.ajax_url,
                cache: false,
                type: "POST",
                data: {
                    'action': 'j3w_contact_form',
                    'data': self.$contactForm.serialize()
                },
                beforeSend: function () {
                    self.$contactForm.addClass("waiting");
                },
                success: function (data) {
                    self.$contactForm.find(".cf-alert").html(data);
                    if (data === 'Email byl úspěšně odeslán') {
                        self.$contactForm.find('input[type="text"], input[type="email"], textarea').val("");
                    }
                    self.$contactForm.removeClass("waiting");
                    self.contactAjax = false;
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    console.log('J3W: AJAX error - contactFormSubmit() - ' + errorThrown);
                    self.$contactForm.removeClass("waiting");
                    self.contactAjax = false;
                }
            });

        },

        contactFormValidate: function () {

            var self = this;

            if (self.contactAjax) {
                return false;
            }

            // validate form
            self.$contactForm.validate({

                highlight: function (element, errorClass, validClass) {
                    $(this).find(".cf-alert").html("");
                    $(element).addClass(errorClass).removeClass(validClass);
                    $(element.form).find("#" + element.id).addClass(errorClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(errorClass).addClass(validClass);
                    $(element.form).find("#" + element.id).removeClass(errorClass);
                },
                submitHandler: function (form) {
                    self.contactFormSubmit();
                }

            });

        },

        photoSwipeInit: function () {

            var self = this;

            var i = 0;

            self.$photoSwipeItem.each( function() {

                $(this).attr("data-index", i);
                i++;

            });

            var items = self.photoSwipeItems( self.$photoSwipeItem );

            var $pswp = $('.pswp')[0];

            self.$photoSwipeItem.on('click', function (event) {

                var $index = $(this).data("index");
                var options = {
                    index:            $index,
                    bgOpacity:        0.95,
                    showHideOpacity:  true,
                    preload:          [2, 2]
                };

                // Initialize PhotoSwipe
                var lightBox = new PhotoSwipe( $pswp, PhotoSwipeUI_Default, items, options );

                lightBox.init();

                event.preventDefault();

            });

        },

        photoSwipeItems: function( $figure ){

            var items = [];

            $figure.find("a").each( function() {

                var href   = $(this).attr('href'),
                    size   = $(this).data('size') ? $(this).data('size').split('x') : [1200, 900],
                    width  = size[0],
                    height = size[1],
                    caption = $(this).closest("figure").find("figcaption").text();

                var item = {
                    src:    href,
                    w:      width,
                    h:      height,
                    title:  caption
                };

                items.push(item);

            });

            return items;

        }

    };

    // Add core script to $.j3wTheme so it can be extended
    $.j3wTheme = J3WTheme.prototype;

    $(document).ready(function () {

        function isIE() {
            var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
            var msie = ua.indexOf('MSIE '); // IE 10 or older
            var trident = ua.indexOf('Trident/'); //IE 11

            return (msie > 0 || trident > 0);
        }

        if(isIE()){
            $(".chromeframe").fadeIn(200);
        }

        $("#chromeframe-close").on("click", function(){
            $("#chromeframe").fadeOut(200);
        });

        // Initialize script
        new J3WTheme();
    });

})(jQuery);